import { render, staticRenderFns } from "./AppPos.vue?vue&type=template&id=21c23fb4&"
import script from "./AppPos.vue?vue&type=script&lang=js&"
export * from "./AppPos.vue?vue&type=script&lang=js&"
import style0 from "./AppPos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports